module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-f155ab5a.png";